export const MenuKeys: Record<string, PermissionMenuKeys> = {
  Employee: 'employee',
  Department: 'department',
  Position: 'position',
  Offices: 'offices',
  Pipeline: 'pipeline',
  Contract: 'contract',
  Invoice: 'invoice',
  KPI: 'kpi',
  Product: 'product',
  Schedule: 'schedule',
  Classes: 'classes',
  Teachers: 'teachers',
  'Teaching Assistant': 'teaching_assistant',
  Dashboard: 'dashboard',
  Configure: 'configure',
  Access: 'access',
  Management: 'management',
};

export const MenuInfo: PermissionMenuList = {
  dashboard: {
    path: '/dashboard',
    label: 'Bảng điều khiển',
    icon: 'Dashboard',
    sub: {
      dashboard: {
        path: '/dashboard',
        icon: 'Dashboard',
        label: 'Tổng quan',
        permission: [
          'business_revenue_view_all',
          'business_revenue_view_only',
          'attendance_rate_view_all',
          'attendance_rate_view_only',
        ],
      },
      revenue_statistics: {
        path: '/dashboard/revenue-statistics',
        icon: 'Statistics',
        label: 'Thống kê doanh thu',
        permission: [
          'business_revenue_view_all',
          'business_revenue_view_only',
          'employee_revenue_view_all',
          'employee_revenue_view_only',
        ],
      },
      contact_statistics: {
        path: '/dashboard/contact-statistics',
        icon: 'Statistics',
        label: 'Thống kê liên hệ',
        permission: [
          'contact_transaction_status_view_all',
          'contact_transaction_status_view_only',
          'contact_gender_view_all',
          'contact_gender_view_only',
          'contact_location_view_all',
          'contact_location_view_only',
          'contact_date_of_birth_view_all',
          'contact_date_of_birth_view_only',
          'contact_source_report_view_all',
          'contact_source_report_view_only',
          'contact_product_view_all',
          'contact_product_view_only',
        ],
      },
      training_statistics: {
        path: '/dashboard/training-statistics',
        icon: 'Statistics',
        label: 'Thống kê đào tạo',
        permission: [
          'daily_schedule_view_all',
          'daily_schedule_view_only',
          'teacher_schedule_view_all',
          'teacher_schedule_view_only',
          'classroom_schedule_view_all',
          'classroom_schedule_view_only',
          'attendance_rate_view_all',
          'attendance_rate_view_only',
        ],
      },
    },
  },
  employee: {
    path: '/employee',
    icon: 'BadgeOutlinedIcon',
    label: 'Quản lý nhân sự',
    permission: ['employee_view_all', 'employee_view_only'],
  },
  sales: {
    path: '/sales',
    icon: 'Insights',
    label: 'Thông tin kinh doanh',
    sub: {
      potentialAccount: {
        path: '/sales',
        icon: 'AccountCircleOutlinedIcon',
        label: 'Leads data',
        permission: ['lead_view_all', 'lead_view_only'],
      },
      contract: {
        path: '/sales/contract',
        icon: 'Gavel',
        label: 'Hợp đồng',
        permission: ['contract_view_all', 'contract_view_only'],
      },
      account: {
        path: '/sales/account',
        icon: 'PersonOutlineOutlined',
        label: 'Khách hàng',
        permission: ['account_view_all', 'account_view_only'],
      },
      invoice: {
        path: '/sales/invoice',
        icon: 'RequestQuote',
        label: 'Hoá đơn',
        permission: ['receipt_view_all', 'payment_view_all'],
      },
      activity: {
        path: '/sales/activity',
        icon: 'AssessmentOutlinedIcon',
        label: 'Hoạt động',
        permission: ['lead_activity_view_all', 'lead_activity_view_only'],
      },
      kpi: {
        path: '/sales/kpi',
        icon: 'WaterfallChart',
        label: 'Chỉ tiêu',
        permission: ['kpi_view_all', 'kpi_view_only'],
      },
    },
  },
  schedule: {
    path: '/schedule',
    icon: 'Schedule',
    label: 'Đào tạo',
    sub: {
      classes: {
        path: '/schedule/classes',
        icon: 'Class',
        label: 'Lớp học',
        permission: ['class_view_all', 'class_view_only'],
      },
      teachers: {
        path: '/schedule/teachers',
        icon: 'Person',
        label: 'Giáo viên',
        permission: ['teacher_view_all'],
      },
      teaching_assistant: {
        path: '/schedule/teaching-assistant',
        icon: 'Assistant',
        label: 'Cố vấn học tập',
        permission: ['teacher_view_all'],
      },
      student: {
        path: '/schedule/student',
        icon: 'SchoolIcon',
        label: 'Học sinh',
        permission: ['contract_view_student'],
      },
    },
  },
  setting: {
    path: '/setting',
    icon: 'Settings',
    label: 'Cài đặt',
    sub: {
      request_approval: {
        path: '/setting/request-approval',
        icon: 'PlaylistAddCheckIcon',
        label: 'Yêu cầu chờ phê duyệt',
        permission: ['request_view_all'],
      },
      master_data: {
        path: '/setting/master-data',
        icon: 'DatasetOutlined',
        label: 'Dữ liệu chung',
      },
      group_access: {
        path: '/setting/accessibility',
        icon: 'SettingsAccessibility',
        label: 'Quyền truy cập',
        permission: ['group_permission_view_all', 'group_permission_view_only'],
      },
    },
  },
};
